export function ContactSection() {
  return (
    <section id="contact" className="py-12 md:py-16 px-4 md:px-6 bg-background-100/70">
      <div className="max-w-[720px] mx-auto">
        <div className="text-center mb-8 md:mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-3">
            投稿爆料
          </h2>
          <p className="text-sm md:text-base text-foreground-600 max-w-lg mx-auto">
            有猛料？欢迎向我们投稿爆料，严格保护爆料人隐私
          </p>
        </div>

        <a
          href="#contact"
          className="block bg-background-50 rounded-xl p-8 md:p-10 border border-background-200/70 hover:border-primary-300/50 transition-all duration-200 cursor-pointer text-center group"
        >
          <div className="w-16 h-16 mx-auto flex items-center justify-center rounded-full bg-primary-100 mb-4 group-hover:bg-primary-200 transition-colors">
            <i className="ri-mail-send-line text-primary-600 text-2xl"></i>
          </div>
          <h3 className="font-heading font-bold text-xl md:text-2xl text-foreground-950 mb-2">
            tips@heiliao.com
          </h3>
          <p className="text-sm text-foreground-500 max-w-sm mx-auto">
            邮件投稿 · 微信：heiliao_chigua · 匿名加密通道
          </p>
          <div className="mt-5 inline-flex items-center gap-2 px-5 py-2.5 bg-primary-500 text-background-50 font-semibold text-sm rounded-lg group-hover:bg-primary-600 transition-colors">
            <i className="ri-send-plane-line"></i>
            立即发送爆料
          </div>
        </a>
      </div>
    </section>
  );
}

export function RankingSection() {
  const rankings = [
    { rank: 1, title: '某顶流男星深夜私会神秘女子被拍', heat: '986万', tag: '爆', tagColor: 'bg-primary-500' },
    { rank: 2, title: '知名网红直播带货翻车现场实录', heat: '872万', tag: '热', tagColor: 'bg-accent-500' },
    { rank: 3, title: '某女团成员疑似恋情曝光粉丝炸锅', heat: '765万', tag: '热', tagColor: 'bg-accent-500' },
    { rank: 4, title: '娱乐圈又一明星偷税漏税被通报', heat: '698万', tag: '新', tagColor: 'bg-secondary-500' },
    { rank: 5, title: '综艺节目录制现场突发意外引热议', heat: '543万', tag: '新', tagColor: 'bg-secondary-500' },
    { rank: 6, title: '某导演新片选角内幕遭业内人士曝光', heat: '421万', tag: '', tagColor: '' },
    { rank: 7, title: '热门综艺嘉宾私下关系大揭秘', heat: '387万', tag: '', tagColor: '' },
  ];

  return (
    <section id="ranking" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[960px] mx-auto">
        <div className="flex items-center justify-between mb-8 md:mb-10">
          <div>
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-1">
              24小时热度榜
            </h2>
            <p className="text-sm text-foreground-500">实时更新，全网最快吃瓜</p>
          </div>
          <span className="flex items-center gap-1 text-xs text-foreground-400 bg-background-100 px-3 py-1.5 rounded-full">
            <span className="w-1.5 h-1.5 rounded-full bg-green-500 animate-pulse"></span>
            实时更新中
          </span>
        </div>

        <div className="space-y-0">
          {rankings.map((item, i) => (
            <a
              key={i}
              href="#ranking"
              className="flex items-center gap-3 md:gap-4 px-3 md:px-4 py-3 md:py-3.5 hover:bg-background-100/70 rounded-lg transition-colors duration-200 cursor-pointer border-b border-background-200/50 last:border-b-0 group"
            >
              <span
                className={`flex-shrink-0 w-7 h-7 md:w-8 md:h-8 flex items-center justify-center rounded-lg font-bold text-sm ${
                  item.rank <= 3
                    ? 'bg-primary-500 text-background-50'
                    : 'bg-background-200 text-foreground-600'
                }`}
              >
                {item.rank}
              </span>
              <span className="flex-1 text-sm md:text-base text-foreground-800 group-hover:text-primary-600 transition-colors line-clamp-1 font-medium">
                {item.title}
              </span>
              {item.tag && (
                <span className={`flex-shrink-0 px-2 py-0.5 rounded text-[10px] md:text-xs font-bold text-background-50 ${item.tagColor}`}>
                  {item.tag}
                </span>
              )}
              <span className="flex-shrink-0 flex items-center gap-1 text-xs text-foreground-400">
                <i className="ri-fire-line text-[10px]"></i>
                {item.heat}
              </span>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}

export function MediaSection() {
  const mediaItems = [
    {
      title: '某流量明星剧组耍大牌全程录像',
      views: '1256万',
      duration: '03:25',
      tag: '独家',
      imageUrl: 'https://readdy.ai/api/search-image?query=Dramatic%20entertainment%20news%20scene%20with%20paparazzi%20style%20photography%20warm%20lighting%20candid%20moment%20blurred%20background%20editorial%20photojournalism%20style%20rich%20contrast%20and%20texture%20no%20text%20no%20logos&width=640&height=400&seq=media-card-01&orientation=landscape',
    },
    {
      title: '网红情侣分手内幕独家采访',
      views: '982万',
      duration: '05:18',
      tag: '热门',
      imageUrl: 'https://readdy.ai/api/search-image?query=Emotional%20interview%20scene%20with%20soft%20dramatic%20lighting%20two%20people%20talking%20intensely%20documentary%20style%20photography%20warm%20amber%20tones%20shallow%20depth%20of%20field%20cinematic%20look%20no%20text&width=640&height=400&seq=media-card-02&orientation=landscape',
    },
    {
      title: '选秀节目黑幕选手实名举报',
      views: '867万',
      duration: '02:47',
      tag: '爆料',
      imageUrl: 'https://readdy.ai/api/search-image?query=Tense%20press%20conference%20scene%20with%20microphones%20and%20cameras%20dramatic%20lighting%20serious%20atmosphere%20photojournalism%20style%20high%20contrast%20warm%20tones%20no%20text%20no%20logos&width=640&height=400&seq=media-card-03&orientation=landscape',
    },
    {
      title: '娱乐圈大佬饭局录音全文曝光',
      views: '734万',
      duration: '08:12',
      tag: '劲爆',
      imageUrl: 'https://readdy.ai/api/search-image?query=Mysterious%20dimly%20lit%20dinner%20scene%20with%20elegant%20table%20setting%20dramatic%20shadows%20film%20noir%20aesthetic%20warm%20candlelight%20atmosphere%20suspenseful%20mood%20cinematic%20composition%20no%20text&width=640&height=400&seq=media-card-04&orientation=landscape',
    },
  ];

  return (
    <section id="media" className="py-12 md:py-16 px-4 md:px-6 bg-background-100/70">
      <div className="max-w-[960px] mx-auto">
        <div className="mb-8 md:mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-1">
            独家视频
          </h2>
          <p className="text-sm text-foreground-500">第一手影像资料，直击现场</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-4 gap-4 md:gap-5">
          {mediaItems.map((item, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl overflow-hidden border border-background-200/70 hover:border-primary-300/50 transition-all duration-200 cursor-pointer group"
            >
              <div className="relative aspect-[16/10] bg-background-200/80 overflow-hidden">
                <img
                  src={item.imageUrl}
                  alt={item.title}
                  className="w-full h-full object-cover group-hover:scale-105 transition-transform duration-500"
                />
                <div className="absolute inset-0 bg-gradient-to-t from-black/60 via-transparent to-transparent"></div>
                <div className="absolute top-3 left-3">
                  <span className="px-2 py-0.5 rounded text-[10px] font-bold text-background-50 bg-primary-500">
                    {item.tag}
                  </span>
                </div>
                <div className="absolute bottom-3 left-3 right-3 flex items-center justify-between">
                  <span className="flex items-center gap-1 text-xs text-background-50/90">
                    <i className="ri-play-circle-fill text-sm"></i>
                    {item.duration}
                  </span>
                  <span className="flex items-center gap-1 text-xs text-background-50/80">
                    <i className="ri-eye-line text-[10px]"></i>
                    {item.views}
                  </span>
                </div>
              </div>
              <div className="p-3 md:p-4">
                <p className="text-sm font-medium text-foreground-800 line-clamp-2 leading-snug group-hover:text-primary-600 transition-colors">
                  {item.title}
                </p>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function AppSection() {
  return (
    <section id="app" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[960px] mx-auto">
        <div className="bg-gradient-to-br from-primary-500 via-primary-600 to-primary-800 rounded-2xl p-6 md:p-10 flex flex-col lg:flex-row items-center gap-6 md:gap-10 overflow-hidden relative">
          <div className="absolute top-0 right-0 w-[300px] h-[300px] rounded-full bg-background-50/10 blur-[80px]"></div>
          <div className="absolute bottom-0 left-0 w-[200px] h-[200px] rounded-full bg-accent-500/20 blur-[60px]"></div>

          <div className="relative z-10 flex-1 text-center lg:text-left">
            <h2 className="font-heading font-bold text-2xl md:text-3xl text-background-50 mb-3">
              手机版官网直达
            </h2>
            <p className="text-sm md:text-base text-background-50/80 leading-relaxed mb-5 max-w-md">
              黑料吃瓜网手机版随时随地畅快吃瓜，最新地址自动适配移动端，
              无需下载APP，浏览器输入<strong className="text-background-50">黑料吃瓜网入口</strong>即可免费观看最新内容。
            </p>
            <div className="flex flex-col sm:flex-row items-center gap-3">
              <a
                href="#hero"
                className="inline-flex items-center gap-2 px-5 py-2.5 bg-background-50 text-primary-600 font-semibold text-sm rounded-lg hover:bg-background-100 transition-colors duration-200 whitespace-nowrap cursor-pointer"
              >
                <i className="ri-smartphone-line text-lg"></i>
                手机版入口
              </a>
              <span className="text-xs text-background-50/60">
                支持 iOS / Android 浏览器访问
              </span>
            </div>
          </div>

          <div className="relative z-10 flex-shrink-0">
            <div className="w-[180px] md:w-[220px] aspect-[9/16] rounded-2xl overflow-hidden border-4 border-background-50/20 bg-background-50/10">
              <img
                src="https://readdy.ai/api/search-image?query=A%20modern%20smartphone%20mockup%20displaying%20a%20news%20and%20entertainment%20app%20interface%20with%20dark%20theme%20trending%20topics%20cards%20and%20headlines%20sleek%20UI%20design%20warm%20color%20accents%20clean%20layout%20professional%20app%20screenshot%20style&width=440&height=780&seq=app-mobile-preview&orientation=portrait"
                alt="黑料吃瓜网手机版界面预览"
                className="w-full h-full object-cover"
              />
            </div>
          </div>
        </div>
      </div>
    </section>
  );
}

export function CommentsSection() {
  const comments = [
    {
      avatar: '吃瓜群众A',
      time: '2小时前',
      content: '这个瓜太猛了！！我就说之前就觉得不对劲，果然出事了，坐等后续发展！已转发好友群。',
      likes: '3.2k',
      badge: '铁粉',
    },
    {
      avatar: '八卦小能手',
      time: '5小时前',
      content: '一直在关注这个事件，文章分析得很透彻。建议大家都来看黑料吃瓜网，全网最快最全的爆料都在这里了。',
      likes: '2.8k',
      badge: '资深',
    },
    {
      avatar: '路人甲',
      time: '8小时前',
      content: '第一次来黑料吃瓜网站就停不下来了，信息量太大了，每一个都是真材实料，比微博热搜靠谱多了。',
      likes: '1.9k',
      badge: '',
    },
    {
      avatar: '真相挖掘机',
      time: '12小时前',
      content: '这个黑料吃瓜网入口太方便了，手机版也能直接看，不用到处找最新地址，收藏了收藏了。',
      likes: '1.5k',
      badge: '新粉',
    },
  ];

  return (
    <section id="comments" className="py-12 md:py-16 px-4 md:px-6 bg-background-100/70">
      <div className="max-w-[960px] mx-auto">
        <div className="mb-8 md:mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-1">
            读者热评
          </h2>
          <p className="text-sm text-foreground-500">百万吃瓜群众的真实声音</p>
        </div>

        <div className="space-y-4">
          {comments.map((c, i) => (
            <div
              key={i}
              className="bg-background-50 rounded-xl p-4 md:p-5 border border-background-200/70"
            >
              <div className="flex items-start gap-3">
                <div className="w-9 h-9 md:w-10 md:h-10 rounded-full bg-primary-100 flex items-center justify-center flex-shrink-0">
                  <span className="text-primary-600 font-bold text-sm">
                    {c.avatar.charAt(0)}
                  </span>
                </div>
                <div className="flex-1 min-w-0">
                  <div className="flex items-center gap-2 mb-1.5">
                    <span className="font-semibold text-sm text-foreground-900">{c.avatar}</span>
                    {c.badge && (
                      <span className="px-1.5 py-0.5 rounded text-[10px] font-medium bg-accent-100 text-accent-700">
                        {c.badge}
                      </span>
                    )}
                    <span className="text-xs text-foreground-400">{c.time}</span>
                  </div>
                  <p className="text-sm text-foreground-700 leading-relaxed">{c.content}</p>
                  <div className="flex items-center gap-4 mt-2">
                    <span className="flex items-center gap-1 text-xs text-foreground-400 cursor-pointer hover:text-primary-500 transition-colors">
                      <i className="ri-thumb-up-line"></i>
                      {c.likes}
                    </span>
                    <span className="text-xs text-foreground-400 cursor-pointer hover:text-primary-500 transition-colors">
                      回复
                    </span>
                  </div>
                </div>
              </div>
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}

export function IndexSection() {
  const items = [
    { title: '明星绯闻', desc: '最新恋情、婚变、出轨爆料', icon: 'ri-heart-pulse-line', color: 'bg-primary-100 text-primary-600' },
    { title: '网红黑料', desc: '直播翻车、人设崩塌合集', icon: 'ri-user-unfollow-line', color: 'bg-accent-100 text-accent-600' },
    { title: '综艺内幕', desc: '选秀黑幕、节目潜规则', icon: 'ri-tv-2-line', color: 'bg-secondary-100 text-secondary-600' },
    { title: '影视八卦', desc: '剧组爆料、片酬内幕揭秘', icon: 'ri-film-line', color: 'bg-primary-100 text-primary-600' },
    { title: '音乐圈瓜', desc: '歌手争议、版权纠纷追踪', icon: 'ri-music-2-line', color: 'bg-accent-100 text-accent-600' },
    { title: '时尚圈料', desc: '品牌代言、时尚圈内幕', icon: 'ri-shirt-line', color: 'bg-secondary-100 text-secondary-600' },
    { title: '直播圈瓜', desc: '大主播纠纷、平台内斗', icon: 'ri-live-line', color: 'bg-primary-100 text-primary-600' },
    { title: '体育八卦', desc: '运动员私生活、转会内幕', icon: 'ri-basketball-line', color: 'bg-accent-100 text-accent-600' },
    { title: '社会热点', desc: '争议事件、舆论焦点追踪', icon: 'ri-fire-line', color: 'bg-secondary-100 text-secondary-600' },
  ];

  return (
    <section id="index" className="py-12 md:py-16 px-4 md:px-6 bg-background-50">
      <div className="max-w-[960px] mx-auto">
        <div className="mb-8 md:mb-10">
          <h2 className="font-heading font-bold text-2xl md:text-3xl text-foreground-950 mb-1">
            专题索引
          </h2>
          <p className="text-sm text-foreground-500">分类浏览，精准吃瓜</p>
        </div>

        <div className="grid grid-cols-1 sm:grid-cols-2 lg:grid-cols-3 gap-3 md:gap-4">
          {items.map((item, i) => (
            <a
              key={i}
              href="#index"
              className="flex items-start gap-3 p-3 md:p-4 bg-background-50 rounded-xl border border-background-200/70 hover:border-primary-300/50 hover:bg-background-100/50 transition-all duration-200 cursor-pointer group"
            >
              <div className={`w-10 h-10 flex-shrink-0 flex items-center justify-center rounded-lg ${item.color}`}>
                <i className={`${item.icon} text-lg`}></i>
              </div>
              <div className="min-w-0">
                <h3 className="font-heading font-semibold text-sm md:text-base text-foreground-900 group-hover:text-primary-600 transition-colors">
                  {item.title}
                </h3>
                <p className="text-xs text-foreground-500 mt-0.5 line-clamp-1">{item.desc}</p>
              </div>
            </a>
          ))}
        </div>
      </div>
    </section>
  );
}